var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{attrs:{"id":"e-textarea","rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }